import React from 'react'
import { Link } from 'react-router-dom'
import ShowerConfigurator from '../components/ShowerConfigurator'

const LandingPage = () => {
  return (
    <div className="app-shell">
      <header className="app-header">
        <div>
          <h1>Shower Base Configurator</h1>
          <p>Interactive 3D preview that updates as measurements change.</p>
        </div>
        <Link className="primary cta-link" to="/get-a-quote">
          Get a Quote
        </Link>
      </header>
      <ShowerConfigurator />
    </div>
  )
}

export default LandingPage
